<template>
  <div class="authc account-page">
    <div class="header" v-show="showHeader">
      <div class="title">
        实名认证
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'AuthcLayout',
    data() {
      return {
        showHeader: false,
      }
    },
    methods:{
      checkBackFlag(name){
        if (['AuthcHome', 'AuthcSelect', 'AuthFinish'].indexOf(name) !== -1) {
          this.showHeader = true
        } else {
          this.showHeader = false
        }
      }
    },
    watch: {
      $route(to, from) {
        this.checkBackFlag(to.name)

      },
    },
    created(){
      this.checkBackFlag(this.$route.name)
    }
  }
</script>

<style scoped>

</style>
<style>
  .back-btn{
    color: #3a8ee6;
    cursor: pointer;
    margin-right: 10px;
  }
</style>
